import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { http } from "@/lib/auth";
import { Reveal, Eyebrow } from "./Reveal";
import { VehicleCard } from "./VehicleCard";

export const useVehicles = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    http.get("/vehicles").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return items;
};

export const VehiclesSection = () => {
  const { t } = useLang();
  const tv = t.vehicles;
  const items = useVehicles();
  if (items && items.length === 0) return null;
  return (
    <section id="vehicles" data-testid="vehicles-section" className="py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <Eyebrow>{tv.eyebrow}</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[44px] lg:leading-[1.1]">{tv.title}</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300">{tv.subtitle}</p>
          </div>
          <Link to="/vehicles" data-testid="vehicles-view-all" className="group inline-flex shrink-0 items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-bold text-white transition-colors hover:border-[#2F7BFF] hover:bg-[#2F7BFF]/10">
            {tv.viewAll} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(items || []).slice(0, 6).map((v) => <VehicleCard key={v.id} v={v} />)}
        </div>
      </div>
    </section>
  );
};
